import $http from '@/api';

/**
 * @param endpoint Example '/api/content/suggest_taxons'
 * @param payload
 * @returns {AxiosPromise<any>}
 */
const suggestTags = (endpoint, payload) => $http.post(endpoint, payload);

export default {
  suggestTags,
};
